export const primary: string = '#1890ff'
export const lightRed: string = 'rgba(255, 82, 82, 0.5)'
export const lightGreen: string = 'rgba(0, 137, 123, 0.5)'
export const blue: string = '#0080ff'
export const red: string = '#ff5252'
export const hoverDarkRed: string = '#d73e3e'
export const green: string = '#00897B'
export const background: string = '#e0e3eb'
export const black: string = '#000000'
export const white: string = '#FFFFFF'
export const lightBlack: string = '#454545'
export const lightGrey: string = '#F0F3F9'
export const darkGrey: string = '#787B86'
export const textColor: string = '#131722'
export const orange: string = '#ffa726'
export const darkBg: string = '#141721'
export const loginPageTextColor: string = '#D1D4DC'
export const loginPageDividerColor: string = '#2b2e38'
export const loginPageButtonColor: string = '#373a44'
export const iconSelectionColor: string = '#3876EE'
export const darkThemeBg = 'rgb(20, 23, 33)'
export const marketStatusOpenBg: string = '#08998130'
export const marketStatusCloseBg: string = '#ff525230'
export const preMarketOpenBg: string = '#fb8c0030'
export const postMarketOpenBg: string = '#2962FF30'
export const dividerColor: string = '#181818'
export const marketStatusGreen: string = '#22AB94'
export const marketStatusOrange: string = '#FF9800'
export const marketStatusBlue: string = '#2962FF'
export const marketStatusCas: string = '#9C27B0'
export const casOpenBg: string = '#9C27B030'
export const casTextColor: string = '#9C27B0'
export const niftyColor = '#D256F1'
export const bankNiftyColor = '#F1B851'
export const indexFutureColor = '#6D67E4'
export const preMarketTextColor: string = '#fb8c00'
export const primaryDrawingColor: string = '#2962ff'
export const rectangleDrawingColor: string = '#9b27b0'
export const brushDrawingColor: string = '#00bcd4'
export const buyColor = '#4184f3'
export const candleUpColorAlpha = `${buyColor}80`
export const areaTopColor = 'rgba(65, 132, 243, 0.4)'
export const areaBottomColor = 'rgba(65, 132, 243, 0)'
export const baselineTopFillColor1 = `${buyColor}00`
export const baselineTopFillColor2 = `${buyColor}47`
export const sellColor = '#ff5722'
export const paneDividerColor = '#3876EE33'

// Order Status
export const openStatus = '#2962ff'
export const cancelledStatus = '#ff9800'
export const filledStatus = '#089981'
export const rejectedStatus = '#f23645'
export const inactiveStatus = '#707070'
